import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { validate } from "../../../constants/validationExp";
import { toast } from "react-toastify";
import { SagaActions } from "../../../redux/actionTypes";
import { Col, Spinner } from "react-bootstrap";
import { InputWrapper } from "../auth.styled";
import prodLogo from "../../../assets/images/logo_prod_1.png";
import devLogo from "../../../assets/images/logo_dev.png";
import stageLogo from "../../../assets/images/logo_stage.png";

import RenderIf from "../../../components/renderIf";
import { getSignUpOtpReq } from "../../../api/auth/otpRequests";
import { registerWithPswdReq } from "../../../api/auth/registerReq";

import mailIcon from "../../../assets/svgIcons/mail-icon.svg";
import inactive_check_circle from "../../../assets/icons/inactive-check-circle.png";
import active_check_circle from "../../../assets/icons/active-check-circle.png";
import appLogo from "../../../assets/images/logo150.png";
import phoneIcon from "../../../assets/svgIcons/telephone-icon.svg";
import MobileNoLayout from "../../../components/compLayouts/mobileNoLayout";
import { ROUTE_NAMES } from "../../../constants/routeNames";

import { useNavigate, useLocation } from "react-router-dom";

type Inputs = {
  firstNameIs: string;
  lastNameIs: string;
  passwordIs: string;
  confPasswordIs: string;
};

type CreatePassBlockProps = {
  onSubmit?: any;
  forgotPassword?: boolean;
  emailVerified?: boolean;
  smsVerified?: boolean;
  userId?: number;
  onSuccess?: () => void;
  isPasswordReset?: boolean;
};

const CreatePswdBlock = (props: CreatePassBlockProps) => {
  const { onSubmit, forgotPassword, emailVerified = false, smsVerified = false, userId, onSuccess, isPasswordReset = false } = props;
  const navigation = useNavigate();
  const Dispatch = useDispatch();
  const currentPath = useLocation().pathname;

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const pwd = watch("passwordIs");
  const passLengthVal = !!pwd && pwd?.length > 7;
  const passSpecialCharVal = validate.password.specialChar.test(pwd);

  const registerUser = async (data: Inputs) => {
    try {
      // Use userId prop if in password reset mode, otherwise use localStorage
      const currentUserId = isPasswordReset ? String(userId || "") : localStorage.getItem("@userId") || "";

      const body = {
        firstName: data?.firstNameIs,
        lastName: data?.lastNameIs,
        emailVerified: emailVerified ? 1 : 0,
        SMSVerified: smsVerified ? 1 : 0,
        password: data?.passwordIs,
        userID: currentUserId,
      };
      const res = await registerWithPswdReq(body);
      toast.success(res?.message);

      // For password reset flow, call onSuccess callback
      if (isPasswordReset && onSuccess) {
        onSuccess();
        reset();
        return;
      }

      if (!res?.data) {
        onSubmit && onSubmit();
        reset();
        return;
      }
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "createPswdBlock",
          methodName: "registerUser",
          type: "info",
        },
      });
      Dispatch({ type: SagaActions.ADD_USERID, payload: res?.data?.id });

      const parentPath = currentPath.substring(
        0,
        currentPath.lastIndexOf(`${ROUTE_NAMES.Signup}`)
      );

      if (res?.data?.role !== 101 || 102) {
        toast.error("You are not authorised to access this")
      }

      if (res?.data?.role == 301 || res?.data?.role == 303 || 101) {
        // Dispatch({
        //   type: SagaActions.UPDATE_NAVBAR_SEETINGS,
        //   payload: { clickableMenu: false },
        // });

        navigation(`${parentPath}${ROUTE_NAMES.Home}/${ROUTE_NAMES.Dashboard}`);
        reset();
        return;
      }
      navigation(
        `${parentPath}${ROUTE_NAMES.Home}/${ROUTE_NAMES.CEP_Dashboard}`
      );
      reset();
    } catch (error: any) {
      // seterrorMsg(error.errorMsg || "");
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "dev",
          message: error?.errorMsg,
          fileName: "createPswdBlock",
          methodName: "registerUser",
          type: "error",
        },
      });
    }
  };

  const _onPress = ({ key, data }: { key: string; data?: any }) => {
    const fun: any = {
      null: () => {},
    };
    fun[key](data);
  };
  return (
    <div className={`inputsContainer h-100 py-2  border-info`}>
      <Col lg={3} xs={4} sm={2} className="m-2 mb-3">
        <div className="logo_block">
          {process.env.REACT_APP__ENV_IS === "prod" && <img src={prodLogo} />}
          {process.env.REACT_APP__ENV_IS === "dev" && <img src={devLogo} />}
          {process.env.REACT_APP__ENV_IS === "stage" && <img src={stageLogo} />}
        </div>
      </Col>
      <div className="inputs_block w-100 py-1 px-lg-4 py-4 px-xs-2  border-info">
        <form
          onSubmit={handleSubmit((data) => {
            registerUser(data);
          })}
          className={` flex-1 d-flex flex-column  mx-3 h-100 border-info`}
        >
          <div className={` flex-1 d-flex flex-column `}>
            <h4 className={`x-lg-text`}>Set up password</h4>
            <p className={`md-text light-text`}>
              Both your email and mobile number is verified. Please go ahead and
              set your password
            </p>
            <div className={`mt-3`}>
              <div className={`d-flex`}>
                <div
                  className={`mb-3 me-2 flex-1 flex-column `}
                  style={{ width: "40%" }}
                >
                  <label className={`md-text`}>First Name</label>
                  <div
                    bg-white
                    className={`d-flex align-items-center rounded h-50 border-0 ${
                      errors?.firstNameIs?.message && "border-danger"
                    }`}
                  >
                    <input
                      className="border-0 bg-white"
                      style={{ width: "100%" }}
                      disabled
                      id="firstName"
                      type={"text"}
                      value={localStorage.getItem("@firstName") || ""}
                    />
                  </div>
                  {errors?.firstNameIs?.message && (
                    <p className={`xx-sm-text text-danger`}>
                      {errors?.firstNameIs?.message}
                    </p>
                  )}
                </div>
                <div
                  className={`mb-3 me-2 flex-1 flex-column`}
                  style={{ width: "40%" }}
                >
                  <label className={`md-text`}>Last Name</label>
                  <div
                    className={`d-flex align-items-center rounded h-50 border-0`}
                  >
                    <input
                      className="border-0 bg-white"
                      id="lastName"
                      style={{ width: "100%" }}
                      type={"text"}
                      disabled
                      value={localStorage.getItem("@lastName") || ""}
                    />
                  </div>
                  {errors?.lastNameIs?.message && (
                    <p className={`xx-sm-text text-danger`}>
                      {errors?.lastNameIs?.message}
                    </p>
                  )}
                </div>
              </div>
              {/* <div className={`mb-3 me-2`}>
                <label className={`md-text mb-1`}>Create Password</label>
                <div
                  className={`d-flex align-items-center rounded h-50 ${
                    errors?.passwordIs?.message && "border-danger"
                  }`}
                >
                  <input
                    className={`flex-grow-1 rounded border border-secondary-subtle`}
                    type={"password"}
                    placeholder=""
                    {...register("passwordIs", {
                      required: "Password required",
                      minLength: {
                        value: 8,
                        message: "Minimum 8 characters",
                      },
                      pattern: {
                        value: validate.password.specialChar,
                        message: "Alphanumeric with 1 special character #%^.",
                      },
                    })}
                  />
                </div>
              </div> */}
              {/* <div className={``}>
                <p
                  className={`xx-sm-text light-text ${
                    !!errors.passwordIs?.message && "text-danger"
                  }`}
                >
                  <span className={`${!!passLengthVal && "text-success"}`}>
                    Minimum 8 characters
                    Min 8 characters,
                  </span>
                  <span className={`${!!passSpecialCharVal && "text-success"}`}>
                    Alphanumeric with 1 special character #%^.
                    special characters
                  </span>
                </p>
              </div> */}
              <div className="">
                <InputWrapper>
                  <p className={`md-text mb-1`}>{"Create Password"}</p>
                  <div className="d-flex ">
                    <div className="flex-grow-1 ">
                      <div
                        className={`input_box  ${
                          errors?.passwordIs?.message && "border-danger"
                        }`}
                      >
                        <input
                          className={`flex-grow-1`}
                          autoComplete="off"
                          type={"password"}
                          placeholder=""
                          {...register("passwordIs", {
                            required: "Password required",
                            minLength: {
                              value: 8,
                              message: "Minimum 8 characters",
                            },
                            pattern: {
                              value: validate.password.specialChar,
                              message:
                                "Alphanumeric with 1 special character #%^.",
                            },
                          })}
                        />
                      </div>
                      <div className={``}>
                        <p
                          className={`xx-sm-text light-text ${
                            !!errors.passwordIs?.message && "text-danger"
                          }`}
                        >
                          <span
                            className={`${!!passLengthVal && "text-success"}`}
                          >
                            {/* Minimum 8 characters */}
                            Min 8 characters,
                          </span>
                          <span
                            className={`${
                              !!passSpecialCharVal && "text-success"
                            }`}
                          >
                            {/* Alphanumeric with 1 special character #%^. */}
                            special characters
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </InputWrapper>
              </div>
              <div className="">
                <InputWrapper>
                  <p className={`md-text mb-1`}>{"Confirm Password"}</p>
                  <div className="d-flex ">
                    <div className="flex-grow-1 ">
                      <div
                        className={`input_box  ${
                          errors?.confPasswordIs?.message && "border-danger"
                        }`}
                      >
                        {/* <div className={`icon_box ms-2`}>
                      <img src={mailIcon} className="" />
                    </div> */}

                        <input
                          className={`flex-grow-1`}
                          autoComplete="off"
                          type={"password"}
                          placeholder=""
                          {...register("confPasswordIs", {
                            required: "Confirm password required",
                            validate: (value) =>
                              value === pwd || "The passwords didn't match",
                          })}
                        />

                        {/* <div className={`icon_box me-2`}>
                      {_validEmail ? (
                        <div className={`p-1`}>
                          <img src={active_check_circle} />
                        </div>
                      ) : (
                        <img src={inactive_check_circle} />
                      )}
                    </div> */}
                      </div>
                      {errors?.confPasswordIs?.message && (
                        <p className={`xx-sm-text text-danger`}>
                          {errors?.confPasswordIs?.message}
                        </p>
                      )}
                    </div>
                  </div>
                </InputWrapper>
              </div>
            </div>
          </div>
          <div className="flex-grow-1  d-flex flex-1"></div>

          <div className={``}>
            <button
              className={`sbmit_btn md-text`}
              type="submit"
              // onClick={() => _onPress({ key: "submit" })}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePswdBlock;
